module.exports = __webpack_public_path__ + "static/media/nike-like-a-lioness-opening.526538a9.gif";